// AuthCallback.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_BASE = 'https://qbo.omnivistaweb.com';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const realmId = params.get('realmId');

    if (code && realmId) {
      axios.post(`${API_BASE}/api/save-auth`, { code, realmId })
        .then(() => {
          localStorage.setItem('authenticated', 'true');
          window.location.href = '/salary-dashboard';
        })
        .catch(() => {
          alert('Failed to save QuickBooks auth info.');
          navigate('/login');
        });
    } else {
      alert('Missing authorization code or realm ID.');
      navigate('/login');
    }
  }, [navigate]);

  return <div style={{ padding: 40 }}>Processing login...</div>;
};

export default AuthCallback;
